import {Routes} from '@angular/router';
import {CurrentSkedTaskListComponent} from './task-list/current-sked-task-list.component';
import {CurrentSkedTaskDetailComponent} from './task-detail/current-sked-task-detail.component';
import {CurrentSkedTaskDetailMobileDetailComponent} from './task-detail/mobile-detail/current-sked-task-detail-mobile-detail.component';
import {CurrentSkedInitialSelectionComponent} from './initial-selection/current-sked-initial-selection.component';
import {CurrentSkedChallengeComponent} from './challenge/current-sked-challenge.component';

export const currentSkedRouting: Routes = [
  {
    path: '',
    component: CurrentSkedInitialSelectionComponent,
  },
  {
    path: 'my-sked',
    component: CurrentSkedTaskListComponent,
    data: {mobileNavShown: false},
  },
  {
    path: 'my-sked/task/:taskId',
    component: CurrentSkedTaskDetailComponent,
    data: {mobileNavShown: false},
  },
  {
    path: 'project/:projectId',
    component: CurrentSkedTaskListComponent,
    data: {mobileNavShown: false},
  },
  {
    path: 'project/:projectId/task/:taskId',
    component: CurrentSkedTaskDetailComponent,
    data: {mobileNavShown: false},
  },
  {
    path: 'challenge/:id',
    component: CurrentSkedChallengeComponent,
    data: {mobileNavShown: false},
  },
  {
    path: ':taskId/:subtaskId',
    component: CurrentSkedTaskDetailMobileDetailComponent,
    data: {mobileNavShown: false},
  },
  {
    path: 'challenges',
    component: CurrentSkedTaskListComponent,
    data: {mobileNavShown: false},
  },
];
